import config from "@/config/config";

import Index from "@/pages/terms-use/index.vue";
import List from "@/pages/terms-use/list/list.vue";
import View from "@/pages/terms-use/view/view.vue";
import New from "@/pages/terms-use/new/new.vue";
import Edit from "@/pages/terms-use/edit/edit.vue";

const modulePermission = config.modules.termsUse;

export default {
  path: "/terms-use",
  name: "terms-use",
  component: Index,
  meta: {
    requiresAuth: true,
    modulePermission: modulePermission,
    requiresPermission: "enabled_read",
  },
  children: [
    {
      path: "list",
      name: "terms-use-list",
      component: List,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: "enabled_read",
      },
    },
    {
      path: ":id",
      name: "terms-use-view",
      component: View,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: "enabled_read",
      },
      props: true,
    },
    {
      path: "new",
      name: "terms-use-new",
      component: New,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: "enabled_create",
      },
    },
    {
      path: ":id/e",
      name: "terms-use-edit",
      component: Edit,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: "enabled_edit",
      },
      props: true,
    },
  ],
};
